<template>
	<div class="modal-card large">
		<div class="modal-card-head">
			<div class="modal-card-title">{{ Operation == 'Edit'? 'Edit aircraft': 'Create aircraft' }}</div>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</div>
		<div class="modal-card-body">
			<div class="mx-4 my-4">
				<div class="columns">
					<div class="column is-one-quarter">
						<b-field :type="{ 'is-danger': isRequired }" :message="{ 'This field is required.': isRequired }">
							<template slot="label">
								<b>Select aircraft model</b>&nbsp;
							</template>
							<b-select placeholder="Select aircraft model"
									  v-model="aircraft.Model"
									  keep-first="true">
								<option v-for="m in models" :value="m">{{ m.Name }}</option>
							</b-select>
						</b-field>
					</div>
					<div class="column is-one-quarter">
						<b-field label="Quantity" :type="{ 'is-danger': isRequired }" :message="{ 'This field is required.': isRequired }">
							<b-input type="number" :min="1" placeholder="Quantity" v-model="aircraft.Quantity" :expanded="false"></b-input>
						</b-field>
					</div>
				</div>
				<div class="columns">
					<div class="column is-half">
						<b-field label="Name" :type="{ 'is-danger': isRequired }" :message="{ 'This field is required.': isRequired }">
							<b-input type="text" placeholder="Name" v-model="aircraft.Name" expanded></b-input>
						</b-field>
					</div>
				</div>
				<div class="columns" v-if="Operation == 'Edit' || Operation == 'Add'">
					<div class="column">
						<b-field v-if="portfolios.length > 0" label="Add to the following portfolio(s)">
							<b-taginput placeholder="Add to the following portfolio(s)"
										autocomplete
										ref="autocomplete"
										:data="filteredPortfolios"
										@typing="filterPortfolios"
										:keep-first="false"
										field="Name"
										v-model="selectedPortfolios">
							</b-taginput>
						</b-field>
						<p v-if="portfolios == null || portfolios.length < 1">You have no existing portfolios. <a @click="goToPortfolioPage">Click here</a> to create a portfolio.</p>
					</div>
				</div>
				<div class="columns" style="margin-bottom: 5px">
					<div class="column is-one-quarter">
						<b-field label="Flight Hours" :type="{ 'is-danger': isRequired || OverMaxUnderMinMission }" :message="{ 'This field is required.': isRequired }">
							<b-input type="number" :disabled="aircraft.UseOEM" :placeholder="aircraft.UseOEM == false ? 'Flight Hours' : aircraft.Model.DefaultFlightHours" v-model="aircraft.FlightHours" :min="MinMissionLength" :step="0.01"></b-input>
						</b-field>
					</div>
					<div class="column is-one-quarter">
						<b-field :type="{ 'is-danger': isRequired || OverMaxUnderMinMission }" :message="{ 'This field is required.': isRequired }">
							<template slot="label">
								<b>Cycles</b>&nbsp;
								<b-tooltip label="Flight hours divided by cycles will give the stage length."
										   position="is-top"
										   multilined>
									<i class="fas fa-question-circle"></i>
								</b-tooltip>
							</template>
							<b-input type="number" :disabled="aircraft.UseOEM" :placeholder="aircraft.UseOEM == false ? 'Cycles' : aircraft.Model.DefaultCycles" v-model="aircraft.Cycles" :min="0"></b-input>
						</b-field>
					</div>
					<div class="column is-one-half">
						<b-field style="margin-top: 40px">
							<b-checkbox v-model="aircraft.UseOEM" @input="checkOEM">Use OEM Default Utilisation</b-checkbox>
							<b-tooltip label="The OEM Default Utilisation for an aircraft model represents the number of flight hours and cycles that the relevant OEM would typically expect an aircraft of that model to incur on an annual basis. Where a user does not have access to flight hour and cycle information they should select the OEM Default Utilisation. "
									   position="is-top"
									   multilined>
								<i class="fas fa-question-circle"></i>
							</b-tooltip>
						</b-field>
					</div>
				</div>
				<p class="is-paddingless" style="color: #EAB8B9; margin-top: 0px; font-size: 12px" v-if="OverMaxUnderMinMission">Your flight hours / cycles equal to more than the minimum mission length ({{ MinMissionLength }}) or less than the maximum mission length ({{ aircraft.Model.MaxMissionLength }}) for this model of aircraft.</p>
				<div v-if="aircraft.Model && aircraft.Model.DegradationFactor > 0" class="columns">
					<div class="column">
						<b-field>
							<b-checkbox v-model="aircraft.ApplyDegradation">Apply degradation factor</b-checkbox>
							<b-tooltip label="A user might wish to select a degradation factor where an aircraft model is out-of-production or an engine on the relevant aircraft is close to overhaul. Degradation percentages will be 4% for Widebody and Single-Aisle and 3% for Turboprop and Regional Jet."
									   position="is-top"
									   multilined>
								<i class="fas fa-question-circle"></i>
							</b-tooltip>
						</b-field>
					</div>
				</div>
				<b-field>
					<b-input type="textarea" placeholder="Notes" v-model="aircraft.Notes"></b-input>
				</b-field>
				<b-field class="is-pulled-right">
					<b-button class="is-secondary" :disabled="OverMaxUnderMinMission" style="margin-right: 10px;" @click="saveAndCreateNew" v-if="!aircraft.Id">Save and create another</b-button>
					<b-button class="is-primary" :disabled="OverMaxUnderMinMission" style="margin-right: 10px;" @click="save">Save</b-button>

				</b-field>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				aircraft: {
					Model: null,
					UseOEM: false,
					Quantity: 1
				},
				portfolios: [],
				selectedPortfolios: [],
				models: [],
				createNew: false,
				filteredPortfolios: [],
				isRequired: false
			}
		},
		props: {
			PortfolioId: String,
			Aircraft: Object
		},
		computed: {
			Operation() {
				if (this.PortfolioId) {
					return "Add To Specific";
				} else if (this.Aircraft && this.Aircraft.Id) {
					return "Edit";
				} else {
					return "Add";
				}
			},
			OverMaxUnderMinMission() {
				if (this.aircraft.Model && this.aircraft.Model.Id) {
					if (((this.aircraft.FlightHours / this.aircraft.Cycles) > this.aircraft.Model.MaxMissionLength) || ((this.aircraft.FlightHours / this.aircraft.Cycles) < this.aircraft.Model.MinMissionLength)) {
						return true;
					} else
						return false;
				} else
					return false;
			},
			MinMissionLength() {
				if (this.aircraft.Model && this.aircraft.Model.Id) {
					return this.aircraft.Model.MinMissionLength
				} else
					return 0;
			}
		},
		mounted() {
			this.$http.get("api/model")
				.then(resp => {
					this.models = resp.data;
					if (this.Operation == "Edit") {
						this.aircraft.Model = this.models.find(m => m.Id == this.Aircraft.ModelId);
					}
					this.isLoading = false;
				})

			this.$http.get("api/portfolio/tagsinput")
				.then(resp => {
					this.portfolios = resp.data;
					this.filteredPortfolios = resp.data;

					if (this.Aircraft && this.Aircraft.PortfolioIds) {
						this.Aircraft.PortfolioIds.forEach(id => {
							this.selectedPortfolios.push(this.portfolios.find(p => p.Id == id));
						})
					}
				})

			if (this.Operation == "Edit") {
				this.aircraft = this.Aircraft;
			}
		},
		methods: {
			close() {
				this.$refs.autocomplete.$refs.autocomplete.isActive = false;
			},
			goToPortfolioPage() {
				this.$router.push('/portfolio');
				this.$parent.close();
			},
			filterPortfolios(text) {
				this.filteredPortfolios = this.portfolios.filter((option) => {
					return option
						.Name
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0;
				})
			},
			checkOEM() {
				if (this.aircraft.UseOEM == true) {
					this.aircraft.FlightHours = this.aircraft.Model.DefaultFlightHours;
					this.aircraft.Cycles = this.aircraft.Model.DefaultCycles;
				}
			},
			async saveAndCreateNew() {
				this.createNew = true;
				await this.save();
			},
			async save() {
				if (this.aircraft.Model && this.aircraft.Model.Id && this.aircraft.Name && this.aircraft.Quantity && this.aircraft.FlightHours && this.aircraft.Cycles) {
					if (this.Operation == "Add To Specific") {
						this.aircraft.PortfolioIds = [];
						this.aircraft.PortfolioIds.push(this.PortfolioId);
					} else {
						let newPortfolios = [];
						this.selectedPortfolios.forEach(a => {
							newPortfolios.push(a.Id);
						})
						this.aircraft.PortfolioIds = newPortfolios;
					}

					this.aircraft.ModelId = this.aircraft.Model.Id;
					try {
						var resp = await this.$http.post("api/aircraft", this.aircraft);
						this.$emit('onSuccess', resp.data);
						this.$buefy.toast.open({
							message: "Aircraft saved.",
							type: "is-success"
						});
						if (this.createNew == true) {
							this.$emit('createNew');
						}
						if (this.Operation == "Edit") {
							this.$emit('refreshManage');
						}
						this.$parent.close();
					}
					catch (err) {
						if (err.response.data.includes("MissionLength exceeds")) {
							this.$buefy.toast.open({
								message: "Aircraft flight hours/cycles exceeds max mission length.",
								type: "is-danger",
								duration: 5000
							});
						} else {
							this.$buefy.toast.open({
								message: "Aircraft failed to save.",
								type: "is-danger"
							});
						}
						this.$emit('onError', resp)

						console.error(err);
					}

				} else {
					this.$buefy.toast.open({
						message: "Please fill out all of the required fields.",
						type: "is-danger"
					});
					this.isRequired = true;
				}




			}
		}
	}
</script>

<style>
</style>
